/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyKit from './pharmacy-kit';
import PharmacyKitDetail from './pharmacy-kit-detail';
import PharmacyKitUpdate from './pharmacy-kit-update';
import PharmacyKitDeleteDialog from './pharmacy-kit-delete-dialog';

const PharmacyKitRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyKit />} />
    <Route path="new" element={<PharmacyKitUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyKitDetail />} />
      <Route path="edit" element={<PharmacyKitUpdate />} />
      <Route path="delete" element={<PharmacyKitDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyKitRoutes;
